import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { routeNames } from 'src/app/app-routing-names';
import { StepService } from '../services/step-service/step.service';
@Injectable({
    providedIn: 'root'
})
export class verifyQuickQuestionsGuard {

constructor(public router: Router,
    private stepService: StepService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let requiredStep = route.data.step as number;
        let redirect = route.data.redirect as string;

        return this.isAllowedNavigate(requiredStep, redirect);
    }

    isAllowedNavigate(requiredStep: number, redirect: string = routeNames.OWN_RENT_PROPERTY): boolean {
        let currentNavigation = this.router.getCurrentNavigation();

        if (this.stepService.quoteFormStep$.value > requiredStep && currentNavigation.trigger == 'popstate') {
            return false;
        }
        return true;
    }
}